import { Icon } from "@iconify/react";
import { Colors } from "../../utils/colors";
import PopupModalContainer, {
  PopupModalContainerWidth,
} from "../Containers/PopupModalContainer";
import RectangleButton from "../Buttons/RectangleButton";
import { useState } from "react";
import { useNavigate } from "../../hooks/useNavigate";
import { onCreatorPanelNavigatePath } from "../../utils/navigationUtils";
import TextHoverButton from "../Buttons/TextHoverButton";
import HelpModal from "../Containers/HelpModal";
import { NavigationId } from "../../navigation/AppParamList";
import { TeamMemberRole } from "@markit/common.types";
import { getAccountState } from "../../redux/slices/accountSlice";
import { useSelector } from "react-redux";

type RequestAccessModalProps = {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
};

const RequestAccessModal = (props: RequestAccessModalProps) => {
  const { isVisible, setIsVisible } = props;
  const { teamMemberData } = useSelector(getAccountState).account;
  const navigate = useNavigate();
  const [helpModal, setHelpModal] = useState(false);

  return isVisible ? (
    <PopupModalContainer
      headerComp={
        <div className="ColumnNormal" style={{ gap: 14 }}>
          <Icon icon="ion:lock-closed-sharp" height={35} />
          <div className="ColumnNormal" style={{ gap: 7 }}>
            <span className="sectionTitle">Request Access</span>
            <span
              style={{ fontWeight: 400, color: Colors.GRAY1, fontSize: 12 }}
            >
              This action/feature is only available for admins/owners. Contact
              your team owner to request access if you believe there has been a
              mistake.
            </span>
          </div>
        </div>
      }
      valueComp={
        <div className="ColumnCentering" style={{ gap: 7 }}>
          <RectangleButton
            buttonLabel={"View Team"}
            onPress={() => {
              onCreatorPanelNavigatePath(
                navigate,
                NavigationId.HOME_SETTINGS,
                teamMemberData?.role === TeamMemberRole.TWO_WAY_SUPPORT ? 1 : 3
              );
              setIsVisible(false);
            }}
            altColor={Colors.BLACK}
            altTextColor={Colors.WHITE}
            containerStyles={{ paddingInline: 14, paddingBlock: 12 }}
          />
          <TextHoverButton
            text="Contact Support"
            onPress={() => setHelpModal(true)}
          />
          {helpModal ? (
            <HelpModal showModal={helpModal} setShowModal={setHelpModal} />
          ) : null}
        </div>
      }
      noExit
      closeOnOutsidePress
      closeModal={() => setIsVisible(false)}
      modalContentWidth={PopupModalContainerWidth.SMALL}
    />
  ) : null;
};

export default RequestAccessModal;
